(function () {
    'use strict';

    function productTypeConfigurationOptionsDataService($http) {
        var baseUrl = '[BuildifyApiHost]/api/producttypeconfigurationoptions/';

        function loadConfigurationOptions(id) {
            return $http.get(baseUrl + id).then(function (response) {
                return response.data;
            });
        };

        return {
            loadConfigurationOptions: loadConfigurationOptions
        }
    }

    productTypeConfigurationOptionsDataService.$inject = ['$http'];

    angular.module('ecap.common').service('productTypeConfigurationOptionsDataService', productTypeConfigurationOptionsDataService);
})();